// extracted by mini-css-extract-plugin
module.exports = {"header":"ViewAttendeePage_header__2BbwX"};